
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy/scc-p2p",
      function () {
        return require("private-next-pages/privacy/scc-p2p.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy/scc-p2p"])
      });
    }
  